module.exports = __webpack_public_path__ + "img/card-bg.7a5e7893.png";